if (!customElements.get('pastael-gifting-order-deadlines')) {
  class PastaelGiftingOrderDeadlines extends HTMLElement {
    connectedCallback() {
      this.counters = this.querySelectorAll('[data-deadline-counter]');
      this.updateAll();
      this.timer = window.setInterval(() => this.updateAll(), 60000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
    }

    updateAll() {
      this.counters.forEach((counter) => {
        const dateValue = (counter.dataset.deadlineDate || '').trim();
        const output = counter.querySelector('[data-days-left]');
        if (!output) return;

        if (!dateValue) {
          output.textContent = '—';
          return;
        }

        const days = this.daysUntil(dateValue);
        output.textContent = days === null ? '—' : String(days);
      });
    }

    daysUntil(dateValue) {
      const match = dateValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!match) return null;

      const parts = match.slice(1).map(Number);
      if (parts.some((part) => Number.isNaN(part))) return null;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const target = new Date(parts[0], parts[1] - 1, parts[2]);
      if (Number.isNaN(target.getTime())) return null;
      target.setHours(0, 0, 0, 0);

      const diffMs = target.getTime() - today.getTime();
      const days = Math.floor(diffMs / 86400000);
      return Math.max(0, days);
    }
  }

  customElements.define('pastael-gifting-order-deadlines', PastaelGiftingOrderDeadlines);
}
